import { render, staticRenderFns } from "./materialSelector.vue?vue&type=template&id=352f7673&scoped=true&"
import script from "./materialSelector.vue?vue&type=script&lang=js&"
export * from "./materialSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352f7673",
  null
  
)

export default component.exports